export const quizCounters = {
    quizStartTest: {
        rbmail: {
            type: 'click',
            id: '79652629',
        },
    },
    quizChooseCat: {
        rbmail: {
            type: 'click',
            id: '79652630',
        },
    },
    quizChooseDog: {
        rbmail: {
            type: 'click',
            id: '79652632',
        },
    },
    quizDogQ1: {
        rbmail: {
            type: 'click',
            id: '79652633',
        },
    },
    quizDogQ2: {
        rbmail: {
            type: 'click',
            id: '79652634',
        },
    },
    quizDogQ3: {
        rbmail: {
            type: 'click',
            id: '79652635',
        },
    },
    quizDogQ4: {
        rbmail: {
            type: 'click',
            id: '79652636',
        },
    },
    quizDogQ5: {
        rbmail: {
            type: 'click',
            id: '79652637',
        },
    },
    quizDogQ6: {
        rbmail: {
            type: 'click',
            id: '79652639',
        },
    },
    quizDogQ7: {
        rbmail: {
            type: 'click',
            id: '79652640',
        },
    },
    quizDogQ8: {
        rbmail: {
            type: 'click',
            id: '79652641',
        },
    },
    quizDogRecommend: {
        rbmail: {
            type: 'click',
            id: '79652761',
        },
    },
    quizCatQ1: {
        rbmail: {
            type: 'click',
            id: '79652642',
        },
    },
    quizCatQ2: {
        rbmail: {
            type: 'click',
            id: '79652643',
        },
    },
    quizCatQ3: {
        rbmail: {
            type: 'click',
            id: '79652644',
        },
    },
    quizCatQ4: {
        rbmail: {
            type: 'click',
            id: '79652645',
        },
    },
    quizCatQ5: {
        rbmail: {
            type: 'click',
            id: '79652646',
        },
    },
    quizCatRecommend: {
        rbmail: {
            type: 'click',
            id: '79652763',
        },
    },
    quizRestart: {
        rbmail: {
            type: 'click',
            id: '79652647',
        },
    },
};
